import { render } from "./PhoneIcon.vue?vue&type=template&id=c20d8eb2&scoped=true"
import script from "./PhoneIcon.vue?vue&type=script&lang=js"
export * from "./PhoneIcon.vue?vue&type=script&lang=js"

import "./PhoneIcon.vue?vue&type=style&index=0&id=c20d8eb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c20d8eb2"]])

export default __exports__